import React from "react";
import { Autocomplete as MUI } from "@material-ui/lab";
import { MdArrowDropDownCircle } from "react-icons/md";
import { Controller } from "react-hook-form";

export const Autocomplete = ({ options, textFieldProps, control, ...rest }) => {
  return (
    <Controller
      control={control}
      render={(propsSec) => (
        <MUI
          // autoComplete={true}
          {...propsSec}
          options={options}
          renderInput={(params) => (
            <div className="flex items-center" ref={params.InputProps.ref}>
              <div className="w-full">
                <input
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "4px",
                    borderColor: "#cbd5e0",
                    border: "1px solid #cbd5e0",
                    outline: "none",
                  }}
                  type="text"
                  placeholder="Select a Center"
                  {...params.inputProps}
                  {...textFieldProps}
                />
              </div>
              <div className="-ml-8">
                <MdArrowDropDownCircle />
              </div>
            </div>
          )}
          // onChange={(_, data) => {
          //   propsSec.onChange(data);
          //   if (props.customChangeCB) props.customChangeCB(data);
          // }}
          {...rest}
        />
      )}
      {...rest}
    />
  );
};
